import { render } from "./AddPageModal.vue?vue&type=template&id=3753519d"
import script from "./AddPageModal.vue?vue&type=script&lang=js"
export * from "./AddPageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__